import { render, staticRenderFns } from "./monster.vue?vue&type=template&id=394fbe37&scoped=true"
import script from "./monster.vue?vue&type=script&lang=js"
export * from "./monster.vue?vue&type=script&lang=js"
import style0 from "./monster.vue?vue&type=style&index=0&id=394fbe37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394fbe37",
  null
  
)

export default component.exports